import { render, staticRenderFns } from "./listv3.vue?vue&type=template&id=f3cad532&scoped=true&"
import script from "./listv3.vue?vue&type=script&lang=js&"
export * from "./listv3.vue?vue&type=script&lang=js&"
import style0 from "./listv3.vue?vue&type=style&index=0&id=f3cad532&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3cad532",
  null
  
)

export default component.exports